export type EquityMarketContractTemplateVariable = {
  token: string;
  labelKey: string;
};

export const EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES: EquityMarketContractTemplateVariable[] =
  [
    { token: '{{nombre_comprador}}', labelKey: 'EquityMarketContractVarBuyerName' },
    { token: '{{nombre_vendedor}}', labelKey: 'EquityMarketContractVarSellerName' },
    { token: '{{dni_comprador}}', labelKey: 'EquityMarketContractVarBuyerId' },
    { token: '{{dni_vendedor}}', labelKey: 'EquityMarketContractVarSellerId' },
    { token: '{{num_acciones}}', labelKey: 'EquityMarketContractVarShareCount' },
    { token: '{{clase_acciones}}', labelKey: 'EquityMarketContractVarShareClass' },
    { token: '{{precio_accion}}', labelKey: 'EquityMarketContractVarPricePerShare' },
    { token: '{{precio_total}}', labelKey: 'EquityMarketContractVarTotalPrice' },
    { token: '{{fecha}}', labelKey: 'EquityMarketContractVarDate' },
    { token: '{{hora}}', labelKey: 'EquityMarketContractVarTime' },
    {
      token: '{{referencia_operacion}}',
      labelKey: 'EquityMarketContractVarOperationRef',
    },
    { token: '{{nombre_sociedad}}', labelKey: 'EquityMarketContractVarSocietyName' },
    { token: '{{cif_sociedad}}', labelKey: 'EquityMarketContractVarSocietyTaxId' },
  ];
